"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useLockBodyScroll = void 0;

var utils_1 = require("@bdl-cmn-shared-packages-npm/utils");

var use_safe_layout_effect_1 = require("./use-safe-layout-effect");

function useLockBodyScroll() {
  use_safe_layout_effect_1.useSafeLayoutEffect(function () {
    if (utils_1.isBrowser) {
      var currentBodyOverflowStyle_1 = window.getComputedStyle(document.body, null).getPropertyValue('overflow');
      document.body.style.setProperty('overflow', 'hidden');
      return function cleanup() {
        document.body.style.setProperty('overflow', currentBodyOverflowStyle_1);
      };
    }
  }, []);
}

exports.useLockBodyScroll = useLockBodyScroll;